import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, WhyChooseUs, Banner, Process, Clients } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <WhyChooseUs />
        <Process />
        <Testimonials />
        <Team />
        <Banner />
        <Clients />

      </section>

    </>
  );
}

export default AboutUs;